'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  project: null,
  depVersions: (0, _immutable.Map)(),
  depPathPrefixes: (0, _immutable.Map)(),
  staticDomain: null
}, 'BenderContext');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/BenderContext.js
// module id = 446
// module chunks = 0